import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection } from "lexical";
import { Box } from "../../../../Box/index.js";
import { $createMentionNode } from "../../nodes/index.js";
const listener = (event, editor)=>{
    if ('@' === event.key && event.shiftKey) {
        event.preventDefault();
        if (editor) editor.update(()=>{
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                const mentionNode = $createMentionNode();
                selection.insertNodes([
                    mentionNode
                ]);
            }
        });
    }
};
const MentionPlugin = ({ children, mention })=>{
    const [editor] = useLexicalComposerContext();
    useEffect(()=>{
        if (!mention) return;
        const removeRootListener = editor.registerRootListener((rootElement, prevRootElement)=>{
            null == rootElement || rootElement.addEventListener('keydown', (e)=>listener(e, editor));
            null == prevRootElement || prevRootElement.removeEventListener('keydown', (e)=>listener(e, editor));
        });
        return ()=>{
            removeRootListener();
        };
    }, []);
    return /*#__PURE__*/ jsx(Box, {
        children: children
    });
};
export { MentionPlugin };
